import { render, staticRenderFns } from "./FoodStockManage.vue?vue&type=template&id=2e8fa28b&scoped=true"
import script from "./FoodStockManage.vue?vue&type=script&lang=js"
export * from "./FoodStockManage.vue?vue&type=script&lang=js"
import style0 from "./FoodStockManage.vue?vue&type=style&index=0&id=2e8fa28b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8fa28b",
  null
  
)

export default component.exports